import { render, staticRenderFns } from "./UpdateFooter.vue?vue&type=template&id=25c9b51e"
import script from "./UpdateFooter.vue?vue&type=script&lang=js"
export * from "./UpdateFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports